import React, { ReactNode, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Dropdown, DropdownButton, Form, Nav, Navbar } from "react-bootstrap";
import Logo from "../assets/images/logo.svg";
import User from "../assets/images/user.svg";
import Ems from "../assets/images/ems.svg";
import Joble from "../assets/images/joble.svg";
import ID from "../assets/images/id.svg";
import CRM from "../assets/images/crm.svg";
import Pro from "../assets/images/pro.svg";
import Pays from "../assets/images/pays.svg";
import "./layout.css";
import { GoSearch } from "react-icons/go";
import { TbGridDots } from "react-icons/tb";
import { SiAmazonaws } from "react-icons/si";
import routes from "routes";
import { useDispatch, useSelector } from "react-redux";
import { getUserData, logout, retrieveUserData } from "redux/authSlice";
import { UserData } from "model/auth-model";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import { PiUserCircle } from "react-icons/pi";
import { BiLogOut } from "react-icons/bi";
import { useGetPermissionsByIdQuery } from "api/userManagementApi";

type Props = {
  children: any;
};

const Layout = ({ children }: Props) => {
  const location = useLocation();
  const pathname = location.pathname;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [showMenu, setShowMenu] = useState(false);

  const handleLogout = () => {
    //localStorage.removeItem("user-token");
    dispatch(logout()); // Dispatch the action to update the authentication status
    navigate(routes.AdminLogin); // Redirect the user to the login page
  };

  const userData: UserData = useSelector(getUserData);

  const userRoleId = retrieveUserData()?.roleId || "";

  const {
    data: userPermissionsData,
    isFetching: fetchingPermission,
    refetch: refetchUserPermission,
  } = useGetPermissionsByIdQuery(userRoleId, {
    skip: userRoleId ? false : true,
  });
  useEffect(() => {
    if (userPermissionsData?.data) {
      refetchUserPermission();
    }
  }, []);
  const viewRequestPermission =
    userPermissionsData?.data &&
    userPermissionsData?.data?.permissions?.includes("View Requests");
  const viewUserPermission =
    userPermissionsData?.data &&
    userPermissionsData?.data?.permissions?.includes("View Users");
  const viewSubPermission =
    userPermissionsData?.data &&
    userPermissionsData?.data?.permissions?.includes("View Subscriptions");
  const viewActivityPermission =
    userPermissionsData?.data &&
    userPermissionsData?.data?.permissions?.includes("View Activity Logs");
  const viewDashboardPermission =
    userPermissionsData?.data &&
    userPermissionsData?.data?.permissions?.includes("View Dashboard");
  const viewEnterprisePermission =
    userPermissionsData?.data &&
    userPermissionsData?.data?.permissions?.includes("View Enterprise Plan");
  const viewSettingsPermission =
    userPermissionsData?.data &&
    userPermissionsData?.data?.permissions?.includes("View Settings");
  const viewWalletPermission =
    userPermissionsData?.data &&
    userPermissionsData?.data?.permissions?.includes("View Wallet");

  return (
    <main className="layout bg-light">
      <div className="sticky-top bg-light">
        <header className="header">
          <Navbar
            collapseOnSelect
            expand="xl"
            sticky="top"
            variant="light"
            className="p-0 mb-0"
          >
            <Navbar.Brand href="/" className="d-flex align-items-center">
              <img src={Logo} width="120px" />
              <span className="version-tag ms-1">
                v{process.env.REACT_APP_VERSION}
              </span>
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav className="me-5"></Nav>
              <Nav className="me-5"></Nav>
              <Nav className="mx-auto my-0 px-2 py-0">
                {/* <Form className='m-auto headerSearch'>
                  <div className='d-flex light-text search-area'><GoSearch size={23} /><Form.Control type='text' placeholder='Search' className='rounded-5 search-input light-text' /></div>
                </Form> */}
              </Nav>
              {/* <Nav className="mx-auto my-2 px-2 py-0">
                <button type='button' onClick={()=>navigate('/weavr-corporate')} className='btn-primary w-100 mx-auto py-2 px-4'>Weavr Corporate</button>
              </Nav> */}
              <Nav className="ms-auto"></Nav>
              <Nav className="m-0 p-0">
                <div className="my-auto me-3">
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="success"
                      id="dropdown-basic"
                      className="text-start text-secondary bg-transparent border-0"
                    >
                      <span className="font-size-smm">
                        {userData?.roleName}
                      </span>
                      <br />
                      <span className="text-dark">
                        {userData?.firstName} {userData?.lastName}
                      </span>
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="border-0">
                      <Dropdown.Item href="/user-management" className="my-1">
                        <PiUserCircle /> User Settings
                      </Dropdown.Item>
                      <Dropdown.Item
                        href=""
                        onClick={() => handleLogout()}
                        className="my-1"
                      >
                        <BiLogOut /> Logout
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </Nav>
            </Navbar.Collapse>
          </Navbar>
        </header>
        <section className="navigation-tabs pt-3 d-flex justify-content-start">
          {(viewDashboardPermission ||
            userData?.roleName === "Super Admin") && (
              <button
                onClick={() => navigate(routes.Dashboard)}
                className={
                  pathname === "/"
                    ? "btn-primary-outline me-3"
                    : "btn-secondary-outline me-3"
                }
              >
                Dashboard
              </button>
            )}
          {(viewSubPermission || userData?.roleName === "Super Admin") && (
            <button
              onClick={() => navigate(routes.Subscription)}
              className={
                pathname === "/subscription"
                  ? "btn-primary-outline me-3"
                  : "btn-secondary-outline me-3"
              }
            >
              Manage packages
            </button>
          )}
          {(viewWalletPermission || userData?.roleName === "Super Admin") && <button onClick={() => navigate(routes.Wallet)} className={pathname === "/wallet" ? "btn-primary-outline me-3" : "btn-secondary-outline me-3"}>Wallet</button>}
          {(viewActivityPermission || userData?.roleName === "Super Admin") && (
            <button
              onClick={() => navigate(routes.ActivityLog)}
              className={
                pathname === "/activity-log"
                  ? "btn-primary-outline me-3"
                  : "btn-secondary-outline me-3"
              }
            >
              Activity Log
            </button>
          )}
          {(viewUserPermission || userData?.roleName === "Super Admin") && (
            <button
              onClick={() => navigate(routes.UserManagement)}
              className={
                pathname === "/user-management"
                  ? "btn-primary-outline me-3"
                  : "btn-secondary-outline me-3"
              }
            >
              User Management
            </button>
          )}
          {(viewRequestPermission || userData?.roleName === "Super Admin") && (
            <button
              onClick={() => navigate(routes.Request)}
              className={
                pathname === "/request"
                  ? "btn-primary-outline me-3"
                  : "btn-secondary-outline me-3"
              }
            >
              Request
            </button>
          )}
          {(viewSettingsPermission || userData?.roleName === "Super Admin") && (
            <button
              onClick={() => navigate(routes.Settings)}
              className={
                pathname === "/settings"
                  ? "btn-primary-outline me-3"
                  : "btn-secondary-outline me-3"
              }
            >
              Settings
            </button>
          )}
          {(viewEnterprisePermission ||
            userData?.roleName === "Super Admin") && (
              <button
                onClick={() => navigate(routes.EnterprisePlan)}
                className={
                  pathname === "/enterprise-plan" || pathname.startsWith("/company-details")
                    ? "btn-primary-outline me-3"
                    : "btn-secondary-outline me-3"
                }
              >
                Companies
              </button>
            )}
        </section>
        <div className="w-100 mobile-menu">
          <button
            type="button"
            onClick={() => setShowMenu(!showMenu)}
            className="btn-secondary-outline w-100"
          >
            Navigation Menu {showMenu ? <FiChevronUp /> : <FiChevronDown />}
          </button>
          <div hidden={!showMenu} className="w-100">
            {(viewDashboardPermission ||
              userData?.roleName === "Super Admin") && (
                <button
                  onClick={() => navigate(routes.Dashboard)}
                  className={
                    pathname === "/"
                      ? "btn-primary-outline me-3 w-100 my-1"
                      : "btn-secondary-outline me-3 w-100 my-1"
                  }
                >
                  Dashboard
                </button>
              )}
            {(viewSubPermission || userData?.roleName === "Super Admin") && (
              <button
                onClick={() => navigate(routes.Subscription)}
                className={
                  pathname === "/subscription"
                    ? "btn-primary-outline me-3 w-100 my-1"
                    : "btn-secondary-outline me-3 w-100 my-1"
                }
              >
                Manage packages
              </button>
            )}
            {(viewWalletPermission || userData?.roleName === "Super Admin") && (
              <button
                onClick={() => navigate(routes.Wallet)}
                className={
                  pathname === "/wallet"
                    ? "btn-primary-outline me-3 w-100 my-1"
                    : "btn-secondary-outline me-3 w-100 my-1"
                }
              >
                Wallet
              </button>
            )}
            {(viewActivityPermission ||
              userData?.roleName === "Super Admin") && (
                <button
                  onClick={() => navigate(routes.ActivityLog)}
                  className={
                    pathname === "/activity-log"
                      ? "btn-primary-outline me-3 w-100 my-1"
                      : "btn-secondary-outline me-3 w-100 my-1"
                  }
                >
                  Activity Log
                </button>
              )}
            {(viewUserPermission || userData?.roleName === "Super Admin") && (
              <button
                onClick={() => navigate(routes.UserManagement)}
                className={
                  pathname === "/user-management"
                    ? "btn-primary-outline me-3 w-100 my-1"
                    : "btn-secondary-outline me-3 w-100 my-1"
                }
              >
                User Management
              </button>
            )}
            {(viewRequestPermission ||
              userData?.roleName === "Super Admin") && (
                <button
                  onClick={() => navigate(routes.Request)}
                  className={
                    pathname === "/request"
                      ? "btn-primary-outline me-3 w-100 my-1"
                      : "btn-secondary-outline me-3 w-100 my-1"
                  }
                >
                  Request
                </button>
              )}
            {(viewSettingsPermission ||
              userData?.roleName === "Super Admin") && (
                <button
                  onClick={() => navigate(routes.Settings)}
                  className={
                    pathname === "/settings"
                      ? "btn-primary-outline me-3 w-100 my-1"
                      : "btn-secondary-outline me-3 w-100 my-1"
                  }
                >
                  Settings
                </button>
              )}
            {(viewEnterprisePermission ||
              userData?.roleName === "Super Admin") && (
                <button
                  onClick={() => navigate(routes.EnterprisePlan)}
                  className={
                    pathname === "/enterprise-plan" || pathname.startsWith("/company-details")
                      ? "btn-primary-outline me-3 w-100 my-1"
                      : "btn-secondary-outline me-3 w-100 my-1"
                  }
                >
                  Companies
                </button>
              )}
          </div>
        </div>
      </div>
      <section className="content-section" style={pathname === '/request' ? { overflow: 'hidden' } : {}}>{children}</section>
    </main>
  );
};

export default Layout;
